import React, { useState, useEffect } from "react";
import { Row, Col, Container, Modal } from "react-bootstrap";
import Course from "./Course";
import Loading from "./Loading";
import ContactModal from "./ContactModal";
import HighlightCourseLayout from "./CourseLayout";

const url = "https://backend.seinimlicht.de/wp-json/wp/v2/";

const Courses = () => {
	const [categories, setCategories] = useState([]);
	const [courses, setCourses] = useState([]);
	const [selectedCourse, setSelectedCourse] = useState(null);

	useEffect(() => {
		async function loadPosts() {
			const response = await fetch(`${url}posts?categories= 15,14,13,6&per_page=50`);
			if (!response.ok) return;
			const posts = await response.json();
			setCourses(posts);
		}

		async function loadCategories() {
			const response = await fetch(`${url}categories?include=15,6,14,13`);
			if (!response.ok) return;

			const categoriesList = await response.json();
			setCategories(categoriesList);
		}

		loadPosts();
		loadCategories();
	}, []);

	const getCoursesByCategory = (categoryId) => {
		return courses.filter((course) => course.categories.includes(categoryId));
	};

	const getSubtitle = (html) => {
		const match = html.match(/<h4[^>]*>(.*?)<\/h4>/);
		return match ? match[1] : "";
	};

	return (
		<div id="coursesTop" className="gray-background">
			{categories.length && courses.length ? (
				<section>
					<Container>
						<Row>
							<Col md={12}>
								<h2 className="display-6">COACHING | EVENTS | KURSE | Workshops</h2>
							</Col>
						</Row>

						{categories.map((category) => (
							<div key={category.id}>
								<Row>
									<Col md={12}>
										<h2 style={{ marginBottom: "10px", marginTop: "30px" }}>
											{category.name}
										</h2>
									</Col>
								</Row>
								<Row className="row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
									{getCoursesByCategory(category.id).map((course) => (
										<Col key={course.id}>
											<Course
												course={course}
												onClick={() => setSelectedCourse(course)}
											/>
										</Col>
									))}
								</Row>
							</div>
						))}
					</Container>
					<Modal
						show={selectedCourse !== null}
						onHide={() => setSelectedCourse(null)}
						size="lg"
						centered
					>
						{selectedCourse && (
							<>
								<Modal.Header closeButton>
									<Modal.Title
										className="ingeborgHeader"
										id="contained-modal-title-vcenter"
									>
										{selectedCourse.title.rendered}
									</Modal.Title>
								</Modal.Header>
								<Modal.Body>
									<HighlightCourseLayout
										title={selectedCourse.title.rendered}
										subtitle={getSubtitle(selectedCourse.content.rendered)}
										image={selectedCourse.yoast_head_json?.og_image?.[0]?.url}
										content={selectedCourse.content.rendered
											.replace(/<img[^>]*>/g, "") 
											.replace(/<p>\s*<\/p>/g, "") 
											.replace(/<p>&nbsp;<\/p>/g, "") 
											.replace(/\s*<br\s*\/?>\s*<br\s*\/?>\s*/g, "<br>")
											.trim()}
										contactSubject={selectedCourse.title.rendered}
									/>
									<div className="text-left mt-4">
										<ContactModal
											classes="btn-secondary"
											btntitle="Anfragen"
											subject={selectedCourse.title.rendered}
										/>
									</div>
								</Modal.Body>
							</>
						)}
					</Modal>
				</section>
			) : (
				<Loading />
			)}
		</div>
	);
};

export default Courses;
